import type { Subscription } from "../../Graphql/types/subscription";

export interface PlanBundle {
  planName: string;
  features: Array<{ name: string; included: boolean }>;
  isPrimary: boolean;
}

/** Shared plan label + feature rows for subscription cards (matches SubscriptionView logic). */
export function planBundleForSubscription(
  subscription: Subscription
): PlanBundle {
  let planName = "Standard plan";
  let features: Array<{ name: string; included: boolean }> = [];

  if (subscription.priceAmount === 0) {
    planName = "Free tier";
    features = [
      { name: "Product Management", included: true },
      { name: "Item Level Tracking", included: false },
      { name: "QR Code Scanning", included: false },
      { name: "Basic Reporting", included: true },
      { name: "Advanced Analytics", included: false },
      { name: "Multi-Store Support", included: false }
    ];
  } else if (subscription.priceAmount === 25000) {
    planName = "Standard plan";
    features = [
      { name: "Product Management", included: true },
      { name: "Item Level Tracking", included: true },
      { name: "QR Code Scanning", included: false },
      { name: "Basic Reporting", included: true },
      { name: "Advanced Analytics", included: false },
      { name: "Multi-Store Support", included: true }
    ];
  } else if (subscription.priceAmount === 30000) {
    planName = "Premium plan";
    features = [
      { name: "Product Management", included: true },
      { name: "Item Level Tracking", included: true },
      { name: "QR Code Scanning", included: true },
      { name: "Basic Reporting", included: true },
      { name: "Advanced Analytics", included: true },
      { name: "Multi-Store Support", included: true }
    ];
  }

  const isPrimary =
    subscription.priceAmount === 25000 && subscription.status === "ACTIVE";

  return { planName, features, isPrimary };
}
